import { defineStore } from 'pinia'

interface ConfigState {
  imgToImg: boolean
  designThingCard: boolean
  modelIds: string[]
  imgTo3D: boolean
  imgToVideo: boolean
}

export const useConfigStore = defineStore('config', {
  state: (): ConfigState => ({
    imgToImg: false, //工具-以图生图-是否展示New标识
    designThingCard: false, //工具-好物设计-是否展示New标识
    modelIds: [], //工具-模型-需要展示New的模型Id
    imgTo3D: false, //工具-图生3D-是否展示New标识
    imgToVideo: false //工具-图生视频-是否展示New标识
  }),
  actions: {
    setNewTagConfig(config: any) {
      this.imgToImg = config.imgToImg
      this.designThingCard = config.designThingCard
      this.modelIds = config.modelIds
      this.imgTo3D = config.imgTo3D
      this.imgToVideo = config.imgToVideo
    }
  },
  getters: {
    getImgToImg: state => state.imgToImg,
    getDesignThingCard: state => state.designThingCard,
    getModelIds: state => state.modelIds,
    getImgTo3D: state => state.imgTo3D,
    getImgToVideo: state => state.imgToVideo
  }
})
